import dayjs, { Dayjs } from 'dayjs';

export const formatDate = (date: string | Date | Dayjs) => dayjs(date).format('YYYY-MM-DD');

export const parseUserDate = (date: string | Date | Dayjs) => dayjs(date).tz('America/Bogota');

export const formatApiDate = (date: string | Date | Dayjs) => dayjs(date).utc().toISOString();

export const formatDateWithTime = (date: string | Date | Dayjs) =>
  dayjs(date).tz('America/Bogota').format('YYYY-MM-DD HH:mm A');
